/* eslint-disable no-return-assign */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function ViewSOA({ data, showTransaction, id, onRevoke, isRevoking }) {
  const [iframeKey, setIframeKey] = useState(1)
  const setModal = useContext(ModalContext);
  const [remarks, setRemarks] = useState('')

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    showTransaction(id);
  };

  const token = get('token') || '';

  const authProfile = getJson('profile') || {};

  const src = `${process.env.REACT_APP_WS}${c.TBPLS_PERMIT_URI_GENERATE.replace(
    '{id}',
    _.get(data, 'id')
  )}?bearer_token=${token}&email=${_.get(
    authProfile,
    'email'
  )}&soa_remarks=${_.get(data, 'soa_remarks')}&output=I`;

  const onSubmitRevoke = e => {
    e.preventDefault()
    onRevoke(_.get(data, 'id'), remarks)
  }

  useEffect(() => {

    setRemarks('')
    setIframeKey(_.random(1, 1000))
  }, [_.get(data, 'included.module.attributes.is_revoked')])

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Statement of Account"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {!_.get(data, 'included.module.attributes.is_revoked') ? (
            <>
              <input
                className="form-control w-50"
                placeholder="Revoke Remarks..."
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
              &nbsp;
              <button disabled={isRevoking || !remarks} type="button" onClick={onSubmitRevoke} className="btn btn-danger ">
                <span className="font-weight-bold">Revoke</span>
              </button>
              &nbsp;
            </>
          )
            : (
              <>
                <input
                  className="form-control w-50"
                  placeholder="Unrevoke Remarks..."
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
                &nbsp;
                <button disabled={isRevoking || !remarks} type="button" onClick={onSubmitRevoke} className="btn btn-danger ">
                  <span className="font-weight-bold">Unrevoke</span>
                </button>
                &nbsp;
              </>
            )}
          <button disabled={isRevoking} type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>

        </div>
      </form>
    </Modal.Body>
  );
}

ViewSOA.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.instanceOf(String).isRequired,
  onRevoke: PropTypes.instanceOf(Function).isRequired,
  isRevoking: PropTypes.bool.isRequired
};

const mapStateToProps = ({ api }) => ({
  isRevoking: _.get(api, 'loading', []).indexOf(c.BPLS_TEMP_REVOKE) > -1,
  data: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewSOA);
